/* NEO® PDP interactions: gallery (image + video media), swatches, per-ring bundle selects, cart, sticky ATC, reveals */
(function () {
  "use strict";

  function money(cents) {
    return "$" + (cents / 100).toFixed(2);
  }

  var SWATCH_COLORS = {
    "chrome": "linear-gradient(135deg,#f6f6f7 0%,#b9bcc0 45%,#eceded 100%)",
    "gold": "linear-gradient(135deg,#f0debb 0%,#B89A62 50%,#ecd6a8 100%)",
    "rose gold": "linear-gradient(135deg,#f6d6c6 0%,#d29380 50%,#f6dccb 100%)",
    "onyx": "linear-gradient(135deg,#4b4b4e 0%,#121211 55%,#3c3c40 100%)"
  };

  function init() {
    var root = document.getElementById("NeoPdp");
    if (!root) return;

    var dataEl = document.getElementById("NeoVariantData");
    var pdpData = { variants: [], ebook: null };
    if (dataEl) {
      try {
        pdpData = JSON.parse(dataEl.textContent);
      } catch (err) {
        /* corrupt variant data must never kill the gallery/cart interactions */
        pdpData = { variants: [], ebook: null };
      }
    }
    var variants = pdpData.variants || [];
    var ebookId = pdpData.ebook || null;

    var form = document.getElementById("NeoAtcForm");
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var qtyInput = form ? form.querySelector('input[name="quantity"]') : null;

    var mainMedia = document.getElementById("NeoMainMedia");
    var mediaItems = mainMedia ? Array.prototype.slice.call(mainMedia.querySelectorAll(".neo-gallery__item")) : [];
    var thumbs = Array.prototype.slice.call(root.querySelectorAll(".neo-thumb"));
    var swatches = Array.prototype.slice.call(root.querySelectorAll(".neo-swatch"));
    var bundles = Array.prototype.slice.call(root.querySelectorAll(".neo-bundle"));

    var priceEls = Array.prototype.slice.call(document.querySelectorAll("[data-neo-price]"));
    var strikeEls = Array.prototype.slice.call(document.querySelectorAll("[data-neo-strike]"));
    var savingsEl = document.getElementById("NeoSavings");
    var swatchLabel = document.getElementById("NeoSwatchLabel");
    var stickySub = document.getElementById("NeoStickySub");

    var state = { ring1: null, ring2: null, bundleLabel: "" };

    function findVariant(id) {
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].id === id) return variants[i];
      }
      return variants[0];
    }

    function activeBundle() {
      for (var i = 0; i < bundles.length; i++) {
        if (bundles[i].classList.contains("is-active")) return bundles[i];
      }
      return bundles[0] || null;
    }

    /* show one gallery item (image or video) by media id; pause videos leaving the stage */
    function showMedia(id) {
      if (!mediaItems.length || !id) return;
      mediaItems.forEach(function (it) {
        var on = it.getAttribute("data-media-id") === id;
        it.classList.toggle("is-active", on);
        var vid = it.querySelector("video");
        if (vid) {
          if (on) {
            vid.muted = true;
            var pr = vid.play();
            if (pr && pr.catch) pr.catch(function () {
              /* source may still be loading (it was display:none) — play as soon as it can */
              var retry = function () {
                vid.removeEventListener("canplay", retry);
                var p2 = vid.play();
                if (p2 && p2.catch) p2.catch(function () {});
              };
              vid.addEventListener("canplay", retry);
            });
          } else if (!vid.paused) {
            vid.pause();
          }
        }
      });
      thumbs.forEach(function (x) {
        var on = x.getAttribute("data-media-id") === id;
        x.classList.toggle("is-active", on);
        if (on && x.scrollIntoView) x.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "nearest" });
      });
    }

    function paintDots() {
      bundles.forEach(function (b) {
        var d1 = b.querySelector('[data-dot="1"]');
        var d2 = b.querySelector('[data-dot="2"]');
        if (d1) d1.style.background = SWATCH_COLORS[findVariant(state.ring1).title.toLowerCase()] || "#ccc";
        if (d2) d2.style.background = SWATCH_COLORS[findVariant(state.ring2).title.toLowerCase()] || "#ccc";
      });
    }

    function render() {
      var v = findVariant(state.ring1);
      if (!v) return;
      var b = activeBundle();
      var qty = b ? parseInt(b.getAttribute("data-qty"), 10) : 1;
      var payQty = b ? parseInt(b.getAttribute("data-pay-qty"), 10) : 1;
      state.bundleLabel = b ? b.getAttribute("data-label") : "";

      var pay = v.price * payQty;
      var strike = qty === 1 ? (v.compare || v.price) : v.price * qty;
      var save = strike - pay;

      priceEls.forEach(function (el) { el.textContent = money(pay); });
      strikeEls.forEach(function (el) {
        el.textContent = strike > pay ? money(strike) : "";
        el.style.display = strike > pay ? "" : "none";
      });
      if (savingsEl) {
        var msg = b ? b.getAttribute("data-savings-msg") : "";
        savingsEl.innerHTML = (msg || "You're saving {amount} today").replace("{amount}", "<strong>" + money(save) + "</strong>") + " 🎉";
      }
      if (idInput) idInput.value = v.id;
      if (qtyInput) qtyInput.value = qty;
      if (swatchLabel) swatchLabel.textContent = v.title;
      if (stickySub) {
        var subTitle = v.title;
        if (qty === 2) {
          var v2 = findVariant(state.ring2);
          subTitle = v.title + " + " + v2.title;
        }
        stickySub.textContent = subTitle + " · " + state.bundleLabel;
      }
      paintDots();
    }

    function setRing1(id, fromSwatch) {
      state.ring1 = id;
      var v = findVariant(id);
      /* sync all ring-1 selects */
      root.querySelectorAll('select[data-ring="1"]').forEach(function (s) { s.value = String(id); });
      /* sync swatch row */
      swatches.forEach(function (s) {
        s.classList.toggle("is-active", parseInt(s.getAttribute("data-variant-id"), 10) === id);
      });
      /* gallery follows ring 1 */
      if (v && v.image) {
        for (var ti = 0; ti < thumbs.length; ti++) {
          if (thumbs[ti].getAttribute("data-full") === v.image) {
            showMedia(thumbs[ti].getAttribute("data-media-id"));
            break;
          }
        }
      }
      render();
    }

    /* thumbs: switch the stage to the tapped media (image or video) */
    thumbs.forEach(function (t) {
      t.addEventListener("click", function () {
        showMedia(t.getAttribute("data-media-id"));
      });
    });

    /* swatch row (controls ring 1) */
    swatches.forEach(function (s) {
      s.addEventListener("click", function () {
        setRing1(parseInt(s.getAttribute("data-variant-id"), 10), true);
      });
    });

    /* per-ring selects inside bundles */
    root.querySelectorAll(".neo-bundle select").forEach(function (sel) {
      sel.addEventListener("click", function (e) { e.stopPropagation(); });
      sel.addEventListener("change", function () {
        var id = parseInt(sel.value, 10);
        if (sel.getAttribute("data-ring") === "1") {
          setRing1(id, false);
        } else {
          state.ring2 = id;
          render();
        }
      });
    });

    /* bundle card selection */
    bundles.forEach(function (b) {
      function activate() {
        bundles.forEach(function (x) { x.classList.remove("is-active"); });
        b.classList.add("is-active");
        render();
      }
      b.addEventListener("click", function (e) {
        if (e.target && (e.target.tagName === "SELECT" || e.target.tagName === "OPTION")) return;
        activate();
      });
      b.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") { e.preventDefault(); activate(); }
      });
    });

    /* add to cart: build items from the active bundle (supports mixed colors) */
    if (form) {
      var nativeSubmit = false;
      form.addEventListener("submit", function (e) {
        if (nativeSubmit) return;
        e.preventDefault();
        var b = activeBundle();
        var qty = b ? parseInt(b.getAttribute("data-qty"), 10) : 1;
        var items;
        if (qty === 2) {
          if (state.ring1 === state.ring2) {
            items = [{ id: state.ring1, quantity: 2 }];
          } else {
            items = [{ id: state.ring1, quantity: 1 }, { id: state.ring2, quantity: 1 }];
          }
          if (ebookId) items.push({ id: ebookId, quantity: 1 });
        } else {
          items = [{ id: state.ring1, quantity: 1 }];
        }
        var drawer = document.querySelector("cart-drawer");
        var payload = { items: items };
        if (drawer) payload.sections = "cart-drawer,cart-icon-bubble";
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify(payload)
        }).then(function (r) {
          if (!r.ok) throw new Error("cart add failed");
          return r.json();
        }).then(function (res) {
          /* open Dawn's cart drawer with fresh contents; fall back to the cart page */
          if (drawer && res && res.sections && typeof drawer.renderContents === "function") {
            try {
              drawer.classList.remove("is-empty");
              drawer.renderContents(res);
              return;
            } catch (err) { /* fall through */ }
          }
          window.location.href = "/cart";
        }).catch(function () {
          nativeSubmit = true;
          form.submit(); /* fallback: plain POST with ring-1 variant */
        });
      });
    }

    /* CTA anchors: desktop returns to the top of the hero; phones land just above the color picker */
    var anchorSwatches = document.querySelector(".neo-swatches");
    document.querySelectorAll('a[href="#NeoBuybox"]').forEach(function (a) {
      a.addEventListener("click", function (e) {
        e.preventDefault();
        if (window.matchMedia("(max-width: 749px)").matches && anchorSwatches) {
          anchorSwatches.scrollIntoView({ behavior: "smooth", block: "start" });
        } else {
          window.scrollTo({ top: 0, behavior: "smooth" });
        }
      });
    });

    /* sticky bar — visible once the buy-box ATC has scrolled above the viewport */
    var sticky = document.getElementById("NeoSticky");
    var sentinel = document.getElementById("NeoAtcButton");
    if (sticky && sentinel) {
      var onScroll = function () {
        sticky.classList.toggle("is-visible", sentinel.getBoundingClientRect().bottom < 0);
      };
      window.addEventListener("scroll", onScroll, { passive: true });
      onScroll();
    }

    /* init state */
    if (variants.length) {
      state.ring1 = variants[0].id;
      state.ring2 = variants[0].id;
    }
    var preselected = root.querySelector(".neo-swatch.is-active");
    if (preselected) state.ring1 = parseInt(preselected.getAttribute("data-variant-id"), 10);
    render();

    /* if the initially shown media is a video, start it (muted autoplay is always allowed) */
    var firstActive = mainMedia ? mainMedia.querySelector(".neo-gallery__item.is-active video") : null;
    if (firstActive) {
      firstActive.muted = true;
      var fp = firstActive.play();
      if (fp && fp.catch) fp.catch(function () {});
    }
  }

  /* reveal-on-scroll + rating-bar fills (page-wide, works without the PDP root) */
  function initReveal() {
    var items = Array.prototype.slice.call(document.querySelectorAll("[data-neo-reveal]"));
    var bars = Array.prototype.slice.call(document.querySelectorAll(".neo-bar__fill[data-pct]"));
    if (!("IntersectionObserver" in window)) {
      bars.forEach(function (b) { b.style.width = b.getAttribute("data-pct") + "%"; });
      return;
    }
    items.forEach(function (el, i) {
      el.classList.add("neo-pre");
      el.style.transitionDelay = (i % 6) * 70 + "ms";
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add("neo-in");
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -6% 0px" });
    items.forEach(function (el) { io.observe(el); });

    var bio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          var b = e.target;
          requestAnimationFrame(function () { b.style.width = b.getAttribute("data-pct") + "%"; });
          bio.unobserve(b);
        }
      });
    }, { threshold: 0.4 });
    bars.forEach(function (b) { bio.observe(b); });
  }

  /* lightbox for review/customer photos ([data-neo-zoom]) */
  function initLightbox() {
    var zoomables = document.querySelectorAll("[data-neo-zoom]");
    if (!zoomables.length) return;
    var box = document.createElement("div");
    box.className = "neo-lightbox";
    box.innerHTML = '<button type="button" class="neo-lightbox__close" aria-label="Close">✕</button><img alt="">';
    document.body.appendChild(box);
    var img = box.querySelector("img");
    function close() {
      box.classList.remove("is-open");
      img.src = "";
      document.body.style.overflow = "";
    }
    box.addEventListener("click", close);
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") close();
    });
    zoomables.forEach(function (el) {
      el.addEventListener("click", function () {
        img.src = el.getAttribute("data-neo-zoom");
        box.classList.add("is-open");
        document.body.style.overflow = "hidden";
      });
    });
  }

  function boot() { init(); initReveal(); initLightbox(); }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
